<template>
  <div class="column is-one-fifth">
    <h1 class="title is-3">Instruktörer</h1>
    <nav class="panel">
      <a
        class="panel-block"
        v-for="instructor in instructors"
        :class="{ 'is-active': selectedInstructor._id == instructor._id }"
        :key="instructor.id"
        @click="selectInstructor(instructor)"
      >
        {{ instructor.first_name }} {{ instructor.last_name }}
      </a>
    </nav>
    <div class="new-instructor">
      <NewInstructor @reloadInstructors="reloadInstructors"></NewInstructor>
    </div>
  </div>
</template>

<script>
import NewInstructor from "@/components/AdminInstructors/NewInstructor.vue";

export default {
  name: "InstructorsList",
  props: {
    instructors: Array,
  },
  components: {
    NewInstructor,
  },
  data: function () {
    return {
      selectedInstructor: {},
    };
  },
  methods: {
    selectInstructor: function (instructor) {
      this.selectedInstructor = instructor;
      this.$emit("instructorSelected", instructor);
    },
    reloadInstructors: function () {
      this.$emit("reloadInstructors");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.new-instructor {
  padding-left: 0.5rem;
  padding-right: 1rem;
  text-align: left;
}

.is-active {
  background-color: hsl(217, 71%, 53%);
  color: white !important;
  border-radius: 10px;
}

.panel {
  border: None;
}

.panel-tabs {
  border: None;
  border-top: None !important;
}

.panel-block {
  border: None !important;
  color: hsl(0, 0%, 40%);
}

.panel-block:hover {
  color: hsl(0, 0%, 40%) !important;
  border-radius: 10px;
}

.column {
  padding-right: 0.5rem;
  padding-left: 1.25rem;
  box-shadow: inset 0 0 5px 0 #dfdfdf;
  background-color: hsl(0, 0%, 98%);
}
</style>